import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

const AboutReviewModal = () => {
  const { t } = useTranslation("clientBooking");

const handleClose = () => {
    window.loadModal2("#aboutReviewModal", "hide");
  };

  return (
    <div
      className="modal fade bd-example-modal-lg mt-5"
      id="aboutReviewModal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="aboutReviewModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-lg modal-dialog-preview">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="aboutReviewModalLabel">
              {t("aboutReviews.title")}
            </h5>
             <button
              type="button"
              className="close about-us-review-close"
              aria-label={t("buttons.close")}
              onClick={handleClose} // 👈 manual close
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div className="modal-body p-5">
            <p className="review-Popup">
              {t("aboutReviews.p1")}
            </p>
            <br />
            <p className="review-Popup">
              {t("aboutReviews.p2")}
            </p>
            <br />
            <p className="review-Popup"> 
              {t("aboutReviews.p3")}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutReviewModal;
